<template>
  <v-container fluid>
    <SidebarNavigation />

    <v-card class="pa-1">
      <!-- 🔹 TOP BAR (Search + Action) -->
      <v-row class="pa-4">
        <v-col class="d-flex justify-end align-center">
          <!-- BUTTON -->
          <v-btn color="primary" class="mr-2" @click="openDialogCreate">
            <v-icon left>mdi-plus</v-icon>
            Tambah Data
          </v-btn>

          <!-- SEARCH -->
          <v-text-field
            v-model="pagination.search"
            label="Search"
            append-icon="mdi-magnify"
            dense
            hide-details
            outlined
            style="max-width: 250px"
            @input="debouncedSearch"
          />
        </v-col>
      </v-row>

      <!-- 🔹 TABLE -->
      <v-data-table
        mobile-breakpoint="0"
        fixed-header
        dense
        class="elevation-2 mx-4 mb-4"
        :headers="tableHeaders"
        :items="list"
        :items-per-page.sync="pagination.itemsPerPage"
        :page.sync="pagination.page"
        :sort-by="pagination.sortBy"
        :sort-desc="pagination.sortDesc"
        :server-items-length="total"
        item-key="id"
        @update:page="updateQuery('page', $event)"
        @update:items-per-page="updateQuery('itemsPerPage', $event)"
        @update:sort-by="updateQuery('sortBy', $event)"
        @update:sort-desc="updateQuery('sortDesc', $event)"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td class="text-center">{{ item.name }}</td>
              <td class="text-center">{{ item.description }}</td>

              <td class="text-center">
                <v-chip
                  small
                  :color="item.is_active == 1 ? 'green' : 'red'"
                  dark
                >
                  {{ item.is_active == 1 ? "Active" : "Inactive" }}
                </v-chip>
              </td>

              <td class="text-center">
                {{ item.created_by_name || "-" }}
              </td>

              <td class="text-center">
                <div
                  class="d-flex justify-center align-center"
                  style="gap: 6px"
                >
                  <!-- EDIT -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialogUpdate(item)"
                      >
                        <v-icon size="18">mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>

                  <!-- DELETE -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialogDelete(item)"
                      >
                        <v-icon size="18">mdi-delete-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Hapus</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>

    <!-- CREATE -->
    <v-dialog v-model="isDialogOpenCreate" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Tambah</span>
        </v-card-title>

        <v-card-text>
          <v-form v-model="isFormValidCreate">
            <v-text-field
              v-model="name"
              label="Nama"
              :rules="[(v) => !!v || 'Name wajib']"
            />

            <v-text-field
              v-model="description"
              label="Deskripsi"
              :rules="[(v) => !!v || 'description wajib']"
            />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="secondary" @click="isDialogOpenCreate = false">
            Cancel
          </v-btn>

          <v-btn
            color="primary"
            :disabled="!isFormValidCreate"
            @click="submitCreate"
          >
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- update -->
    <v-dialog v-model="isDialogOpenEdit" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Ubah</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValidUpdate">
            <v-text-field
              v-model="name"
              label="Nama"
              :rules="[(v) => !!v || 'Name wajib']"
            />

            <v-text-field
              v-model="description"
              label="Deskripsi"
              :rules="[(v) => !!v || 'description wajib']"
            />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenEdit = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :disabled="!isFormValidUpdate"
            @click="submitUpdate"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DELETE -->
    <v-dialog v-model="isDialogOpenDelete" max-width="400px">
      <v-card>
        <v-card-title class="text-h6"> Konfirmasi Hapus </v-card-title>

        <v-card-text>
          Yakin ingin menghapus data <b>{{ name }}</b
          >?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="grey" text @click="isDialogOpenDelete = false">
            Batal
          </v-btn>

          <v-btn color="red" dark @click="submitDelete"> Hapus </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <snackbarMessage />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    return {
      tabItems: ["UOM"],
      isLoading: false,
      search: "",
      tab: 1,
      tableHeaders: [
        { text: "Nama", align: "center", value: "name" },
        { text: "Deskripsi", align: "center", value: "description" },
        { text: "Status", align: "center", value: "status" },
        { text: "Dibuat Oleh", align: "center", value: "created_by_name" },
        { text: "Aksi", align: "center" },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: true,
        search: "",
      },
      total: null,
      list: [],
      isDialogOpenEdit: false,
      isDialogOpenDelete: false,
      isFormValidUpdate: false,
      isDialogOpenCreate: false,
      isFormValidCreate: false,
      selectedItem: null,
      id: null,
      name: null,
      description: null,
    };
  },
  methods: {
    fetch() {
      store.dispatch("showLoading");
      const query = this.$route.query;
      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: parseInt(query.itemsPerPage) || this.pagination.itemsPerPage,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "name",
        sortDesc: query.sortDesc || this.pagination.sortDesc || false,
        startDate: query.startDate || this.startDate,
        endDate: query.endDate || this.endDate,
      };

      api
        .get("/categories", { params })
        .then(({ data }) => {
          this.list = data.data.data;
          this.total = data.data.total;
        })
        .catch((error) => {
          console.error("Error fetching parameters:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    openDialogCreate() {
      // reset semua field form
      this.name = null;

      // reset validasi form (biar tombol disable lagi)
      this.isFormValidCreate = false;

      // buka dialog
      this.isDialogOpenCreate = true;
    },
    openDialogUpdate(params = null) {
      this.selectedItem = params;
      this.id = params.id;
      this.name = params.name;
      this.description = params.description;
      this.isDialogOpenEdit = true;
    },
    openDialogDelete(params = null) {
      this.selectedItem = params;
      this.id = params.id;
      this.name = params.name;
      this.description = params.description;
      this.isDialogOpenDelete = true;
    },
    submitCreate() {
      store.dispatch("showLoading");

      const payload = {
        name: this.name,
        description: this.description,
      };

      api
        .post("/categories", payload) // ⚠️ sesuaikan endpoint backend kamu
        .then((response) => {
          const message = response.data.message;

          this.fetch(); // refresh table
          this.isDialogOpenCreate = false;

          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: true,
          });
        })
        .catch((error) => {
          let message = "Gagal menambahkan data!";

          if (error.response) {
            message = error.response.data.message || message;
          } else {
            message = error.message || message;
          }

          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    submitUpdate() {
      store.dispatch("showLoading");
      const payload = {
        id: this.id,
        name: this.name,
        description: this.description,
      };
      api
        .post("/categories/update", payload)
        .then((response) => {
          const message = response.data.message;
          this.fetch();
          this.isDialogOpenEdit = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save paramater!";
          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    submitDelete() {
      store.dispatch("showLoading");

      api
        .post("/categories/delete", {
          id: this.id,
        }) // ⚠️ sesuaikan endpoint backend
        .then((response) => {
          const message = response.data.message;

          this.fetch();
          this.isDialogOpenDelete = false;

          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: true,
          });
        })
        .catch((error) => {
          let message = "Gagal menghapus data!";

          if (error.response) {
            message = error.response.data.message || message;
          } else {
            message = error.message || message;
          }

          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },

    debouncedSearch() {
      this.updateQuery("search", this.pagination.search);
    },
    updatePagination(query) {
      // console.log(query);
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.selectedDivisionId = parseInt(query.divisionId) || 0;
      this.selectedPositionId = parseInt(query.positionId) || 0;
      this.selectedSiteId = parseInt(query.siteId) || 0;
    },
    updateQuery(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },
  },
  mounted() {
    store.commit("setTitle", "Kategori Item");
    this.updatePagination(this.$route.query);
  },
  watch: {
    pagination: {
      handler: "fetch",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
  },
};
</script>

<style scoped>
.v-data-table td:nth-child(2),
td:nth-child(4),
td:nth-child(5) {
  text-align: center;
}
</style>
